import React from 'react'
import { PieChart } from 'react-minimal-pie-chart';


export function PieChartUtils({data}) {
    let defaultColors = ['#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f','#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928']
    console.log(data.map(d=>{
        return {title:d.label,value:d.val,color:'red'}
    }))
    return (
        <PieChart
        style={{width:'85%',height:'115px'}}
        
        data={data.map((d,i)=>{
            return {title:d.label,value:parseFloat(d.val),color:defaultColors[i]}
        })}
        />
    )
}
